export interface IReportTemplateViewData {
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
  }
  
  export interface IReportTemplateViewLabel {
    nameLabel: string;
    descriptionLabel: string;
  }
  
  export default class ReportTemplateViewData implements IReportTemplateViewData, IReportTemplateViewLabel {
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
  
    nameLabel: string;
    descriptionLabel: string;
  
    constructor(
      id: string,
      name: string,
      description: string,
      isEnabled: boolean,
    ) {
      this.id = id;
      this.name = name;
      this.description = description;
      this.isEnabled= isEnabled;
  
      this.descriptionLabel = "Description";
      }
  }
  
  const defaultReportTemplateData = new ReportTemplateViewData("", "", "",false);
  export { defaultReportTemplateData };
  